// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyA0loq1NUv2ztaip6fEgEgmar0LCL41BGE",
    authDomain: "e42-io.firebaseapp.com",
    projectId: "e42-io",
    storageBucket: "e42-io.appspot.com",
    messagingSenderId: "980635179197",
    appId: "1:980635179197:web:cdc54e55bb65b49f8effd4",
    measurementId: "G-RTHHETKBLH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const storage = getStorage(app);

// Export the services
export { db, auth, analytics, storage };